(() => {
  function productPricing(product, formatter, fromTemplate) {
    const variants = (product.variants || []).filter(v => v.price !== null && v.price !== '' && Number.isFinite(Number(v.price)));
    const variant = variants.reduce((lowest, v) => !lowest || Number(v.price) < Number(lowest.price) ? v : lowest, null);
    if (!variant) return {variant:null, label:''};
    const amount = formatter.format(Number(variant.price) / 100);
    const varies = new Set(variants.map(v => Number(v.price))).size > 1;
    return {variant, label:varies ? (fromTemplate || '[price]').replace('[price]', amount) : amount};
  }
  const root = window.Shopify?.routes?.root || '/';
  const normalize = value => {
    const s = String(value).trim().toUpperCase();
    return ({SMALL:'S',MEDIUM:'M',LARGE:'L','EXTRA SMALL':'XS','EXTRA LARGE':'XL',XXL:'2XL',XXXL:'3XL',XXXXL:'4XL'})[s] || s;
  };
  const path = handle => root + 'products/' + encodeURIComponent(handle);
  function card(product, variant, strings) {
    const a = document.createElement('a');
    a.className = 'sm-tools-card';
    a.href = variant?.url || path(product.handle);
    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title;
      image.loading = 'lazy';
      image.width = 360;
      image.height = 450;
      a.append(image);
    }
    const title = document.createElement('span');
    title.className = 'sm-tools-card__title';
    title.textContent = product.title;
    const price = document.createElement('span');
    price.textContent = variant?.price || product.price;
    a.append(title, price);
    const badges = document.createElement('span');
    badges.className = 'sm-product-badges';
    const addBadge = (label, kind) => {
      if (!label) return;
      const badge = document.createElement('span');
      badge.className = 'sm-product-badge sm-product-badge--' + kind;
      badge.textContent = label;
      badges.append(badge);
    };
    if (product.available === false) addBadge(strings.sold_out, 'sold');
    else if (variant ? variant.discounted : product.discounted) addBadge(strings.sale, 'sale');
    if (product.final_sale) addBadge(strings.final_sale, 'final');
    if (badges.children.length) a.append(badges);
    return a;
  }
  function recentlyViewed(element) {
    const strings = JSON.parse(element.querySelector('[data-sm-strings]').textContent);
    let handles = [];
    try { handles = JSON.parse(localStorage.getItem('sm_recent_v1') || '[]'); } catch {}
    if (!Array.isArray(handles)) handles = [];
    handles = [...new Set(handles.filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h)))].slice(0,12);
    const current = element.dataset.current;
    const previous = handles.filter(h => h !== current).slice(0,8);
    if (current) {
      try { localStorage.setItem('sm_recent_v1', JSON.stringify([current,...handles.filter(h=>h!==current)].slice(0,12))); } catch {}
    }
    if (!previous.length) return;
    let cleared = false;
    let observer;
    const load = async () => {
      if (cleared) return;
      const results = await Promise.allSettled(previous.map(async handle => {
        const response = await fetch(path(handle) + '.js');
        if (!response.ok) return null;
        const p = await response.json();
        const format = new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:element.dataset.currency});
        const pricing = productPricing(p, format, strings.from_price);
        const variant = pricing.variant;
        if (!variant) return null;
        const vendor = String(p.vendor || '').toLowerCase().replace(/\s/g,'');
        const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(t=>t.trim());
        return {discounted:Number(variant.compare_at_price)>Number(variant.price),final_sale:vendor==='prettybash'||tags.some(t=>['final-sale','final sale','clearance'].includes(t)),handle:p.handle,title:p.title,image:p.featured_image ? new URL(p.featured_image,location.origin).href : '',price:pricing.label,available:p.available};
      }));
      if (cleared) return;
      const grid = element.querySelector('[data-sm-recent-grid]');
      for (const result of results) if (result.status==='fulfilled' && result.value) grid.append(card(result.value,null,strings));
      element.hidden = !grid.children.length;
    };
    element.querySelector('[data-sm-clear]').addEventListener('click',()=>{
      cleared = true;
      observer?.disconnect();
      try { localStorage.removeItem('sm_recent_v1'); } catch {}
      element.hidden = true;
      element.querySelector('[data-sm-recent-grid]').replaceChildren();
    });
    if ('IntersectionObserver' in window) {
      element.hidden = false;
      element.querySelector('[data-sm-recent-grid]').setAttribute('aria-busy','true');
      observer = new IntersectionObserver(entries=>{
        if (!entries.some(e=>e.isIntersecting)) return;
        observer.disconnect();
        load().finally(()=>element.querySelector('[data-sm-recent-grid]').removeAttribute('aria-busy'));
      },{rootMargin:'300px'});
      observer.observe(element);
    } else load();
  }
  function sizeFinder(element) {
    const strings = JSON.parse(element.querySelector('[data-sm-strings]').textContent);
    const form = element.querySelector('form');
    const input = element.querySelector('input');
    const submit = form.querySelector('button[type="submit"]');
    const grid = element.querySelector('[data-sm-size-grid]');
    const status = element.querySelector('[data-sm-size-status]');
    const more = element.querySelector('[data-sm-more]');
    const reset = element.querySelector('[data-sm-reset]');
    const nativeGrid = document.getElementById('ProductGridContainer');
    const nativeFilters = document.getElementById('main-collection-filters');
    const cache = new Map();
    let nextPage = 1, size = '', sizeLabel = '', count = 0, busy = false, generation = 0, matches = [];
    const setBusyState = value => {
      input.disabled = value;
      if (submit) submit.disabled = value;
      more.disabled = value;
      if (value) grid.setAttribute('aria-busy', 'true'); else grid.removeAttribute('aria-busy');
    };
    async function data(page) {
      if (cache.has(page)) return cache.get(page);
      const url = new URL(element.dataset.collection, location.origin);
      url.searchParams.set('section_id','shady-size-data');
      url.searchParams.set('page',String(page));
      const response = await fetch(url);
      if (!response.ok) throw new Error('size data unavailable');
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      const script = doc.querySelector('[data-sm-size-data]');
      if (!script) throw new Error('size data missing');
      const parsed = JSON.parse(script.textContent);
      cache.set(page,parsed);
      return parsed;
    }
    async function load() {
      if (busy || (!nextPage && !matches.length)) return;
      busy = true;
      const version = generation;
      setBusyState(true);
      status.textContent = strings.loading;
      try {
        while(nextPage && matches.length<12 && version===generation) {
          const page = await data(nextPage);
          if (version!==generation) return;
          for (const p of page.products) {
            const variant = p.variants.find(v=>v.available && normalize(v.size)===size);
            if (variant) matches.push({product:p,variant});
          }
          nextPage = page.next;
        }
        for (const match of matches.splice(0,12)) {grid.append(card(match.product,match.variant,strings));count++;}
        status.textContent = count ? strings.found.replace('[count]',count).replace('[size]',sizeLabel) : strings.empty;
        more.hidden = !nextPage && !matches.length;
      } catch {
        status.textContent = strings.error;
        more.hidden = false;
      } finally {
        if (version===generation) {busy=false;setBusyState(false);}
      }
    }
    form.addEventListener('submit',event=>{
      event.preventDefault();
      if (busy) return;
      sizeLabel = input.value.trim();
      size = normalize(sizeLabel);
      if (!size) {input.focus();return;}
      generation++;nextPage=1;count=0;matches=[];grid.replaceChildren();
      element.querySelector('[data-sm-size-results]').hidden=false;
      if(nativeGrid)nativeGrid.hidden=true;
      if(nativeFilters)nativeFilters.hidden=true;
      reset.hidden=false;
      load();
    });
    more.addEventListener('click',load);
    reset.addEventListener('click',()=>{
      generation++;busy=false;input.value='';size='';sizeLabel='';count=0;matches=[];
      setBusyState(false);
      element.querySelector('[data-sm-size-results]').hidden=true;
      grid.replaceChildren();reset.hidden=true;
      if(nativeGrid)nativeGrid.hidden=false;
      if(nativeFilters)nativeFilters.hidden=false;
    });
  }
  function init(scope=document) {
    scope.querySelectorAll('[data-sm-recent]:not([data-sm-ready])').forEach(el=>{el.dataset.smReady='true';recentlyViewed(el);});
    scope.querySelectorAll('[data-sm-size-finder]:not([data-sm-ready])').forEach(el=>{el.dataset.smReady='true';sizeFinder(el);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true}); else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  window.ShadyShoppingTools = {normalize};
})();

